module.exports = __webpack_public_path__ + "img/Overview-active.b0326fa2.png";